import Application from "../../Application";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";
import { ContentTypes } from "../../caseLawDocuments/common/Constants";
import AttachmentTypePresenter, {
  IAttachmentTypePresenter
} from "../presenter/AttachmentTypePresenter";
import GetAllGenericAttachmentTypesInteractor from "./GetAllGenericAttachmentTypesInteractor";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";

export default class ShowAttachmentTypesInteractor {
  private application: Application;
  private output?: IAttachmentTypePresenter;
  private getAllGenericAttachmentTypesInteractor: GetAllGenericAttachmentTypesInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;

  constructor({
    application,
    getAllGenericAttachmentTypes,
    getGenericCodebook,
    getAllOrganisations
  }) {
    this.application = application;
    this.getAllGenericAttachmentTypesInteractor = getAllGenericAttachmentTypes;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getGenericCodebookInteractor = getGenericCodebook;
  }
  private async getContentTypes() {
    return this.getGenericCodebookInteractor.execute(
      ContentTypes.ATTACHMENT_CONTENT_TYPE,
      false
    );
  }
  private async getOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }
  private async getReferenceLists() {
    return Promise.all([this.getContentTypes(), this.getOrganisations()]);
  }
  execute() {
    this.output = AttachmentTypePresenter({
      application: this.application,

      initialState: {
        attachmentTypes: [],
        contentTypes: [],
        organisations: []
      }
    });
    this.getReferenceLists()
      .then(([contentTypes, organisations]) =>
        this.output?.loadAttachmentTypeReferenceValues(
          contentTypes,
          organisations
        )
      )
      .then(() => this.getAllGenericAttachmentTypesInteractor.execute())
      .then(this.output.loadAllAttachmentTypes);
    return this.output;
  }
}
